import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyInputComponent } from './currency-input.component';
import { MatInputModule } from '@angular/material/input';
import { DsiCurrencyModule } from '../dsi-currency/dsi-currency.module';
import { DsiCurrencyPipe } from '../dsi-currency/dsi-currency.pipe';

@NgModule({
    declarations: [CurrencyInputComponent],
    imports: [CommonModule, MatInputModule, DsiCurrencyModule],
    exports: [CurrencyInputComponent],
    providers: [DsiCurrencyPipe],
})
export class CurrencyInputModule {}
